<template>
  <div class="d-flex align-center justify-center flex-nowrap">
    <b class="text-no-wrap">Page {{ page }}</b>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn small v-on="on" text>
          {{ numbers }}/{{ pageSizes[pageSizeIndex] }}
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item-group mandatory v-model="pageSizeIndex">
          <v-list-item v-for="(item, index) in pageSizes" :key="index">
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <custom-pagination
      v-model="page"
      :disable-next="numbers < pageSizes[pageSizeIndex]"
    ></custom-pagination>
  </div>
</template>
<script>
import CustomPagination from '@/components/selects/customPageSelector/CustomPagination';
import { PAGE_SIZES } from '@/store/baseModule/constants';

export default {
  name: 'CustomPageSelector',
  components: { CustomPagination },
  props: {
    namespace: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      nbPages: 2,
      pageSizes: PAGE_SIZES,
    };
  },
  computed: {
    numbers: {
      get() {
        return this.$store.getters[`${this.namespace}/items`].length;
      },
    },
    page: {
      get() {
        return this.$store.getters[`${this.namespace}/page`];
      },
      set(val) {
        this.$store.dispatch(`${this.namespace}/setItemsPage`, val);
      },
    },
    pageSizeIndex: {
      get() {
        return this.$store.getters[`${this.namespace}/pageSizeIndex`];
      },
      set(val) {
        this.$store.dispatch(`${this.namespace}/setItemsPageSize`, val);
      },
    },
  },
  watch: {
    page(page) {
      if (
        this.nbPages === page &&
        this.numbers === PAGE_SIZES[this.pageSizeIndex]
      ) {
        this.nbPages = page + 1;
      }
    },
  },
};
</script>
